import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useEffect,useMemo,useState } from 'react';
import { StoneXLabeledItem } from '..';

interface PropsType {
  value?: Date | null;
  onChange: (date: Date | null) => void;
  label?: string;
  width?: 'small' | string | number;
  error?: string;
  disabled?: boolean;
}

export function StoneXDatePicker(props: PropsType) {

  //when date is undefined, datepicker automatically assumes current day.
  //we prevent the behavior of undefined by converting it to null

  const [open, setOpen] = useState(false);
  const [date, setDate] = useState<Date | null>(props.value ?? null);

  const width = useMemo(() => props.width === 'small' ? '180px' : props.width, [props.width]);

  useEffect(() => {
    props?.onChange(date);
  }, [date])

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <StoneXLabeledItem label={props.label}>
        <DatePicker
          openTo="day"
          views={['year', 'month', 'day']}
          value={date}
          onChange={setDate}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          disabled={props.disabled}
          renderInput={function (params) {
            return <TextField 
              {...params} 
              sx={{ '& .MuiInputBase-root': {width: width}, borderBottom: '1px solid', fieldset: { border: '0px' } }} 
              onClick={(e) => setOpen(true)} 
              error={!!props.error}
              helperText={props.error}
            />;
          }}
        />
      </StoneXLabeledItem>
    </LocalizationProvider>
  );
}
